import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { TokenTimer } from '../../services.module/token.timer';
import { Tuple2 } from '../../model.module/tuple2.model';
import { Router } from '@angular/router';
import { LogoutTimer } from '../../services.module/logout.timer';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeaderComponent implements OnInit {

    cockpitLink = 'kreditportal/cockpit';

    personalShown: boolean = false;
    messagesShown = false;
    minutesLeft: number = 20;

    @Input()
    mobileOpen: boolean = false;

    @Output()
    notifyMobileOpen: EventEmitter<boolean> = new EventEmitter();

    constructor(
        private tokenTimer: TokenTimer,
        private logoutTimer: LogoutTimer,
        private router: Router
    ) {
        tokenTimer.subscribe(this.notifyTime);
    }

    ngOnInit(): void {
        this.logoutTimer.minutesBeforeLogoutObservable.subscribe(
            minutesBeforeLogout => this.applyTime(minutesBeforeLogout)
        );
    }

    applyTime(minutesBeforeLogout: number) {
        this.minutesLeft = minutesBeforeLogout
    }

    notifyTime = (tuple: Tuple2<boolean, number>): void => {
        if (tuple && !tuple.left) {
            this.minutesLeft = tuple.right;
        }
    };

    notifyOpened(num: Number): void {
        switch (num) {
            case 1:
                // we use both to trigger changes.
                this.personalShown = false;
                this.messagesShown = true;
                break;
            case 2:
                this.messagesShown = false;
                this.personalShown = true;
                break;
        }
    }

    toggleOpen() {
        this.mobileOpen = !this.mobileOpen;
        this.notifyMobileOpen.emit(this.mobileOpen);
    }

    goHome() {
        console.debug('cockpitLink', this.cockpitLink);
        this.router.navigate([this.cockpitLink]);
    }

}
